import { render, staticRenderFns } from "./DriversChart.vue?vue&type=template&id=dcd94b18&"
import script from "./DriversChart.vue?vue&type=script&lang=ts&"
export * from "./DriversChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports